import { segment } from '@actions/analytics';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { getBatchSubscriptionByBatchUID } from '@models/Me';
import {
  getBatchGroupSubscriptions,
  getIsUserRegistered,
  getTotalActiveBatches
} from '@selectors/auth';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { subscriptionTypes } from '@constants/index';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';

const usePlatformGroupAnalytics = (goalUID, batch) => {
  const {
    query: { goalUID: routeGoalUID }
  } = useRouter();

  const getSubscriptionType = (type) => {
    const entries = Object.entries(subscriptionTypes);
    const subscribedType = entries.find((entry) => entry[1] === type);
    return subscribedType ? subscribedType[0] : 'NA';
  };
  const isRegistered = useSelector(getIsUserRegistered);
  const selectedGoalUID = useSelectedGoalUID();
  const currGoalUID = goalUID || routeGoalUID || selectedGoalUID;
  const goalSegmentData = useGoalEventProps({ goalUID: currGoalUID });
  const batchGroupSubscriptions = useSelector(getBatchGroupSubscriptions);
  let subscriptionInfo = {};
  if (batch) {
    const { user_subscription_timeline = [{}] } =
      getBatchSubscriptionByBatchUID(batchGroupSubscriptions, batch?.uid) ?? {};
    const {
      time_remaining = 0,
      duration = 0,
      expired_at = 0,
      subscription_type
    } = user_subscription_timeline[0] || {};
    subscriptionInfo = {
      subscription_duration: duration,
      subscription_end_date: expired_at,
      is_subscription_active: time_remaining > 0,
      user_subscription_type: getSubscriptionType(subscription_type)
    };
  }
  const activeBatchSubscriptions = useSelector(getTotalActiveBatches);

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      goal_name: goalSegmentData.goal_name ?? 'NA',
      goal_uid: goalSegmentData.goal_uid,
      subscription_duration: 'NA',
      subscription_end_date: 'NA',
      is_subscription_active: 'NA',
      number_of_active_batch_subscription: activeBatchSubscriptions,
      is_new_user: !isRegistered,
      user_subscription_type: 'NA',
      ...goalSegmentData,
      ...subscriptionInfo,
      ...additionalProps
    });
  };
};

export default usePlatformGroupAnalytics;
